import axios from 'axios';
import type { FeedbackReason } from '@/components/forced-ideation/detail/feedback/reasons';
import {
  ForcedIdeationCreateInput,
  ForcedIdeationDraftInput,
  ForcedIdeationFeedbackType,
  ForcedIdeationInputCheckResult,
  ForcedIdeationJob,
  ForcedIdeationJobInput,
  ForcedIdeationJobListItem,
  ForcedIdeationTrackingPageName,
} from '@/types/forcedIdeation';

export const createForcedIdeationJob = async (
  params: ForcedIdeationCreateInput,
): Promise<ForcedIdeationJob> => {
  const { data } = await axios.post<ForcedIdeationJob>(
    '/forced_ideation',
    params,
  );
  return data;
};

export const getForcedIdeationDrafts = async (): Promise<
  ForcedIdeationJobListItem[]
> => {
  const { data } = await axios.get<ForcedIdeationJobListItem[]>(
    '/forced_ideation/drafts',
  );
  return data;
};

export const createForcedIdeationDraft = async (
  params: ForcedIdeationDraftInput,
): Promise<ForcedIdeationJob> => {
  const { data } = await axios.post<ForcedIdeationJob>(
    '/forced_ideation/drafts',
    params,
  );
  return data;
};

export const updateForcedIdeationDraft = async (
  uuid: string,
  params: ForcedIdeationDraftInput,
): Promise<ForcedIdeationJob> => {
  const { data } = await axios.put<ForcedIdeationJob>(
    `/forced_ideation/drafts/${uuid}`,
    params,
  );
  return data;
};

export const startForcedIdeationDraft = async (
  uuid: string,
): Promise<ForcedIdeationJob> => {
  const { data } = await axios.post<ForcedIdeationJob>(
    `/forced_ideation/drafts/${uuid}/start`,
  );
  return data;
};

export const updateForcedIdeationTitle = async (
  uuid: string,
  title: string,
): Promise<ForcedIdeationJob> => {
  const { data } = await axios.put<ForcedIdeationJob>(
    `/forced_ideation/${uuid}/title`,
    { title },
  );
  return data;
};

export const deleteForcedIdeationJob = async (uuid: string): Promise<void> => {
  await axios.delete(`/forced_ideation/${uuid}`);
};

export const retryForcedIdeationJob = async (
  uuid: string,
): Promise<ForcedIdeationJob> => {
  const { data } = await axios.post<ForcedIdeationJob>(
    `/forced_ideation/${uuid}/retry`,
  );
  return data;
};

export const checkForcedIdeationInput = async (
  params: ForcedIdeationJobInput,
  signal?: AbortSignal,
): Promise<ForcedIdeationInputCheckResult> => {
  const { data } = await axios.post<ForcedIdeationInputCheckResult>(
    '/forced_ideation/input_check',
    params,
    { signal },
  );
  return data;
};

export const createForcedIdeationFeedback = async (params: {
  uuid: string;
  feedback_type: ForcedIdeationFeedbackType;
  reasons: FeedbackReason[];
  comment: string;
  // feedback_submit の計測はサーバ側で発火するため page 情報を渡す
  page: { name: ForcedIdeationTrackingPageName; url: string };
}): Promise<void> => {
  await axios.post(`/forced_ideation/${params.uuid}/feedbacks`, {
    feedback_type: params.feedback_type,
    reasons: params.reasons,
    comment: params.comment,
    page: params.page,
  });
};
